export function removeEmptySpaces(str?: string) {
  return str?.replace(/\s/g, '');
}
